// components/Services.js
import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import '../components/Services.css'; // Import the new CSS file

function Services() {
  return (
    <section id="services" className="py-5">
      <Container>
        <h2 className="text-center mb-5">Our Services</h2>
        <Row>
          <Col md={4} className="mb-4">
            <Card className="service-card">
              <div className="card-img-wrapper">
                <Card.Img variant="top" src="https://cdn.pixabay.com/photo/2017/04/02/03/21/mobile-2194898_1280.jpg" />
              </div>
              <Card.Body>
                <Card.Title>Mobile App Development</Card.Title>
                <Card.Text>We create stunning mobile apps.</Card.Text>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4} className="mb-4">
            <Card className="service-card">
              <div className="card-img-wrapper">
                <Card.Img variant="top" src="https://cdn.pixabay.com/photo/2019/10/09/07/28/development-4536630_1280.png" />
              </div>
              <Card.Body>
                <Card.Title>Web Development</Card.Title>
                <Card.Text>Custom web applications and responsive websites.</Card.Text>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4} className="mb-4">
            <Card className="service-card">
              <div className="card-img-wrapper">
                <Card.Img variant="top" src="https://cdn.pixabay.com/photo/2024/05/02/09/16/web-development-8734249_1280.png" />
              </div>
              <Card.Body>
                <Card.Title>UI/UX Design</Card.Title>
                <Card.Text>User-centric design to enhance user experience.</Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Services;